import { Vector } from "./Vector";
import { Conic } from "./Conic";
import { Time } from "./Time";
import * as Constants from "./Constants";
import { TrajectorySegment } from "./TrajectorySegment";

export class OsculatingTrajectorySegment extends TrajectorySegment {
    centralBodyGM: number;
    elements: number[];

    constructor(data: any) {
        super(data);
        this.centralBodyGM = data.centralBodyGM;
        this.elements = data.elements;
    }

    getPos(time: number): Vector {
        if (time < this.startTime || time > this.endTime)
            throw new RangeError("Time outside valid range");

        // get starting index of nearest set of osculating elements
        let index = Math.round((time - this.startTime) / this.timeStep) * 6;

        if (index >= this.elements.length)
            throw new RangeError("Time outside valid range");

        var conic = new Conic(this.elements[index + 1], this.elements[index], this.elements[index + 2] * Constants.DEGTORAD,
            this.elements[index + 4] * Constants.DEGTORAD, this.elements[index + 3] * Constants.DEGTORAD, this.centralBodyGM, this.elements[index + 5]);

        return conic.getPos(time);
    }
}


// WEBPACK FOOTER //
// ./src/OsculatingTrajectorySegment.ts